// QR.jsx
import React from "react";
import { QRCodeSVG } from "qrcode.react";

const QR = ({
  url,
  showExtras = true,
  sizeOverride,
  headline = "SCAN ME",
  subhead = "Digital Inspection Report",
  footerTop = "Built on Transparency",
  footerBottom = "Driven by Trust",
}) => {
  const size = sizeOverride || 200; // QR pixel size

  return (
    <div className="qr-sign" style={{ "--qr-size": `${size}px` }}>
      {showExtras && (
        <>
          <div className="qr-headline">{headline}</div>
          <div className="qr-subhead">{subhead}</div>
        </>
      )}

      <div className="qr-wrap">
  <QRCodeSVG
    value={url}
    size={size}
    level="Q"
    minVersion={11}
    imageSettings={ showExtras ? {
      src: "q-car-text.png",
      height: 36,
      width: 150,
      excavate: true,
    } : undefined}
  />
  {showExtras && (
  <img src="arrow.png" alt="" className="qr-arrow" />

  )}
</div>

      {showExtras && (
        <div className="qr-footer">
          <div>{footerTop}</div>
          <div>{footerBottom}</div>
        </div>
      )}
    </div>
  );
};

export default QR;
